/**
 * Destinaé — scripts partagés des sections et snippets Destinaé (un seul fichier, chargé en différé).
 * Chaque partie écoute les événements au niveau de la page : elle fonctionne quel que soit
 * le nombre de cartes message, de listes d'attente ou de lignes « Pour qui est-ce ? » affichées.
 */
/* Dates d'envoi : une seule règle pour le calendrier, la livraison estimée et la précommande.
   Jours ouvrés uniquement (ni samedi, ni dimanche, ni jour férié français), heure de Paris.
   Une taille en précommande ne part jamais avant la date de début d'expédition (Réglages du thème). */
(function () {
  if (window.DestinaeDates) return;
  var DAY = 86400000;
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
      da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  /* Jours fériés français : 1er janvier, lundi de Pâques, 1er et 8 mai, Ascension, lundi de Pentecôte,
     14 juillet, 15 août, 1er et 11 novembre, 25 décembre */
  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var e = easter(y);
    cache[y] = [Date.UTC(y, 0, 1), e + DAY, Date.UTC(y, 4, 1), Date.UTC(y, 4, 8), e + 39 * DAY, e + 50 * DAY,
      Date.UTC(y, 6, 14), Date.UTC(y, 7, 15), Date.UTC(y, 10, 1), Date.UTC(y, 10, 11), Date.UTC(y, 11, 25)];
    return cache[y];
  }
  function isHoliday(t) { return holidays(new Date(t).getUTCFullYear()).indexOf(t) !== -1; }
  function isWeekend(t) { var wd = new Date(t).getUTCDay(); return wd === 0 || wd === 6; }
  function isWorkday(t) { return !isWeekend(t) && !isHoliday(t); }
  function today() {
    var p = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var g = function (k) { return Number(p.filter(function (x) { return x.type === k; })[0].value); };
    return Date.UTC(g('year'), g('month') - 1, g('day'));
  }
  /* n jours ouvrés après t (commande le vendredi ou le week-end : expédition le lundi, hors férié) */
  function addWorkdays(t, n) {
    for (var i = 0; i < n; i++) { t += DAY; while (!isWorkday(t)) t += DAY; }
    return t;
  }
  function onOrAfterWorkday(t) { while (!isWorkday(t)) t += DAY; return t; }
  function parse(iso) {
    var x = String(iso || '').split('-').map(Number);
    return (x.length === 3 && !x.some(isNaN)) ? Date.UTC(x[0], x[1] - 1, x[2]) : NaN;
  }
  function iso(t) { return new Date(t).toISOString().slice(0, 10); }
  function label(t, withYear) {
    var o = { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' };
    if (withYear) o.year = 'numeric';
    return new Intl.DateTimeFormat('fr-FR', o).format(new Date(t)).replace(/^(\S+) 1 /, '$1 1er ');
  }
  /* Fenêtre d'envoi : opts = { prep, maxDays, preorder, preStart (AAAA-MM-JJ) } → { min, max, preStart } */
  function window_(opts) {
    var now = today();
    var min = addWorkdays(now, Number(opts.prep) || 0);
    var base = now;
    var pre = opts.preorder ? parse(opts.preStart) : NaN;
    if (!isNaN(pre)) {
      pre = onOrAfterWorkday(pre);
      if (pre > min) min = pre;
      base = pre;
    }
    var max = base + (Number(opts.maxDays) || 90) * DAY;
    while (!isWorkday(max)) max -= DAY;
    return { min: min, max: max, preStart: isNaN(pre) ? null : pre };
  }
  /* Vérifie une date choisie (AAAA-MM-JJ) : renvoie '' si elle convient, sinon le message à afficher */
  function check(value, opts) {
    var t = parse(value);
    if (isNaN(t)) return '';
    var w = window_(opts);
    if (w.preStart && t < w.preStart) return 'Ce bouquet est en précommande : il ne peut pas partir avant le ' + label(w.preStart, true) + '. Choisissez une date à partir de ce jour.';
    if (t < w.min) return 'Choisissez une date à partir du ' + label(w.min, true) + '.';
    if (t > w.max) return 'Choisissez une date au plus tard le ' + label(w.max, true) + '.';
    if (isWeekend(t)) return "Nous n'expédions pas le week-end : choisissez un jour du lundi au vendredi.";
    if (isHoliday(t)) return 'Le ' + label(t).replace(/^\S+ /, '') + " est un jour férié : nous n'expédions pas ce jour-là. Choisissez un autre jour.";
    return '';
  }
  window.DestinaeDates = { today: today, isWorkday: isWorkday, addWorkdays: addWorkdays, parse: parse, iso: iso, label: label, window: window_, check: check };
})();

/* Envoi direct à la personne et date d'envoi souhaitée (fiche produit) */
(function () {
  if (window.dSendReady) return;
  window.dSendReady = true;
  /* Date d'envoi : règle commune (DestinaeDates), enregistrée au format JJ/MM/AAAA.
     Précommande : celle de la taille choisie (attribut posé par destinae-variant-sync). */
  function isPreorder() {
    return document.documentElement.getAttribute('data-d-preorder') === 'true';
  }
  function syncDirect(box) {
    var D = window.DestinaeDates;
    var toggle = box.querySelector('[data-d-direct-toggle]');
    var more = box.querySelector('[data-d-direct-more]');
    var date = box.querySelector('[data-d-direct-date]');
    var value = box.querySelector('[data-d-direct-date-value]');
    var error = box.querySelector('[data-d-direct-error]');
    var preNote = box.querySelector('[data-d-ship-pre]');
    var opts = { prep: date.getAttribute('data-prep'), maxDays: date.getAttribute('data-max-days'), preorder: isPreorder(), preStart: date.getAttribute('data-pre-start') };
    var w = D.window(opts);
    date.min = D.iso(w.min);
    date.max = D.iso(w.max);
    more.hidden = !toggle.checked;
    box.classList.toggle('is-direct', toggle.checked);
    if (preNote) {
      preNote.hidden = !w.preStart;
      if (w.preStart) preNote.textContent = 'Précommande : envoi possible à partir du ' + D.label(w.preStart, true) + '.';
    }
    var msg = date.value ? D.check(date.value, opts) : '';
    if (msg) {
      date.value = '';
      /* Prévient la livraison estimée que la date a été retirée */
      date.dispatchEvent(new Event('change', { bubbles: true }));
    }
    /* Le message d'explication reste affiché jusqu'au choix d'une date valable */
    if (msg) {
      error.textContent = msg;
      error.hidden = false;
    } else if (date.value) {
      error.hidden = true;
    }
    value.disabled = !date.value;
    value.value = date.value ? date.value.split('-').reverse().join('/') : '';
  }
  function syncAllDirect() { document.querySelectorAll('[data-d-direct]').forEach(syncDirect); }
  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest && e.target.closest('[data-d-direct]');
    if (box) syncDirect(box);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAllDirect); else syncAllDirect();
  document.addEventListener('shopify:section:load', syncAllDirect);
  /* Changement de taille : la date déjà choisie est revérifiée (une précommande ne part pas avant sa date) */
  new MutationObserver(syncAllDirect).observe(document.documentElement, { attributes: true, attributeFilter: ['data-d-preorder'] });
})();

/* Choix du montage (fiche produit) : le choix est recopié dans les formulaires de l'offre Duo / Trio de la même page,
   pour que chaque bouquet ajouté porte l'information « Montage ». */
(function () {
  if (window.dMountReady) return;
  window.dMountReady = true;
  function current() {
    var on = document.querySelector('[data-d-mount] input[type="radio"]:checked');
    return on ? on.value : '';
  }
  function mirror() {
    var v = current();
    if (!v) return;
    document.querySelectorAll('[data-d-mount-mirror]').forEach(function (input) { input.value = v; });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-d-mount]')) mirror();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mirror); else mirror();
  document.addEventListener('shopify:section:load', mirror);
})();

/* « Pour qui est-ce ? » sur téléphone : fondu à droite tant que la ligne continue */
(function () {
  if (window.dRowFadeReady) return;
  window.dRowFadeReady = true;
  function check(row) {
    var more = row.scrollWidth - row.clientWidth - row.scrollLeft > 4;
    row.classList.toggle('has-more', more);
  }
  function all() { document.querySelectorAll('.d-msg__presets').forEach(check); }
  document.addEventListener('scroll', function (e) {
    var row = e.target;
    if (row && row.classList && row.classList.contains('d-msg__presets')) check(row);
  }, { passive: true, capture: true });
  window.addEventListener('resize', all);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  document.addEventListener('shopify:section:load', all);
})();

/* Liste d'attente « Prévenez-moi à l'arrivée » */
(function () {
  if (window.dWaitReady) return;
  window.dWaitReady = true;
  function setType(form) {
    var consent = form.querySelector('[data-d-wait-consent]');
    var on = !!(consent && consent.checked);
    var type = form.querySelector('input[name="form_type"]');
    if (type) type.value = on ? 'customer' : 'contact';
    var body = form.querySelector('[data-d-wait-body]');
    if (body) body.disabled = on;
  }
  function done(form) {
    var fields = form.querySelector('.d-wait__fields');
    var ok = form.querySelector('.d-wait__success');
    if (fields) fields.hidden = true;
    if (ok) ok.hidden = false;
    form.classList.add('is-done');
  }
  document.addEventListener('change', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-d-waitlist]');
    if (form) setType(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-d-waitlist]');
    if (!form) return;
    setType(form);
    if (!window.fetch || !window.URLSearchParams) return;
    e.preventDefault();
    var button = form.querySelector('.d-wait__button');
    var error = form.querySelector('.d-wait__error');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Envoi…';
    error.hidden = true;
    var data = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { data.append(k, v); });
    fetch(form.getAttribute('action'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
      credentials: 'same-origin'
    })
      .then(function (r) {
        /* Vérification anti-robots de Shopify : on envoie le formulaire normalement (la page se recharge). */
        if (/\/challenge/.test(r.url)) { form.submit(); return; }
        if (/(contact|customer)_posted=true/.test(r.url)) { done(form); return; }
        throw new Error();
      })
      .catch(function () {
        error.textContent = "L'inscription n'a pas fonctionné. Vérifiez votre adresse e-mail puis réessayez.";
        error.hidden = false;
      })
      .then(function () {
        button.disabled = false;
        button.textContent = label;
      });
  });
  /* Retour après un envoi classique (sans JavaScript ou après la vérification anti-robots) */
  if (/(contact|customer)_posted=true/.test(location.search)) {
    var show = function () { document.querySelectorAll('form[data-d-waitlist]').forEach(done); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show); else show();
  }
})();

/* « Pour qui est-ce ? » */
(function () {
  if (window.dForReady) return;
  window.dForReady = true;
  /* Fiche produit : le bouton du choix en cours (?pour=…) est mis en avant */
  var pour = new URLSearchParams(location.search).get('pour');
  function markCurrent() {
    if (!pour) return;
    document.querySelectorAll('[data-d-for="product"] [data-d-for-key]').forEach(function (a) {
      var on = a.getAttribute('data-d-for-key') === pour;
      a.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  /* Accueil : met en avant le bouquet conseillé et fait défiler jusqu'à lui */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-d-for="home"] [data-d-for-key]');
    if (!btn) return;
    e.preventDefault();
    var root = btn.closest('[data-d-for]');
    root.querySelectorAll('[data-d-for-key]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var scope = btn.closest('section, .shopify-section') || document;
    var productId = btn.getAttribute('data-d-for-product');
    var target = null;
    scope.querySelectorAll('[data-d-reco-product]').forEach(function (o) {
      var on = o.getAttribute('data-d-reco-product') === productId;
      o.classList.toggle('is-reco', on);
      if (on) target = o;
    });
    /* Choisit le bouquet conseillé s'il est disponible */
    if (target && !target.disabled && target.getAttribute('aria-checked') !== 'true') target.click();
    /* Lien vers la fiche, avec le choix (?pour=…) */
    var link = scope.querySelector('[data-d-reco-link]');
    if (link) {
      link.href = btn.getAttribute('data-d-for-url');
      link.querySelector('span').textContent = (link.getAttribute('data-template') || '[bouquet]').replace('[bouquet]', btn.getAttribute('data-d-for-title'));
      link.hidden = false;
    }
    var goTo = target || link;
    if (goTo) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* Carte bouquet (page collection) : son haut s'aligne sous le menu (marge réglée en CSS), badge compris */
      goTo.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: goTo.classList.contains('d-card') ? 'start' : 'center' });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markCurrent); else markCurrent();
})();

/* Changement de coloris (pastilles de la fiche) : la nouvelle fiche reprend le choix du montage,
   l'envoi direct, la date d'envoi et la taille si elle existe pour ce coloris.
   Gardé dans l'onglet (sessionStorage) 10 minutes, jamais dans l'adresse ; effacé dès qu'il est repris. */
(function () {
  if (window.dCarryReady) return;
  window.dCarryReady = true;
  var KEY = 'd-carry';
  function mainPicker() {
    var list = document.querySelectorAll('variant-picker[data-template-product-match="true"]');
    for (var i = 0; i < list.length; i++) if (!list[i].closest('product-card, quick-add-dialog, dialog')) return list[i];
    return null;
  }
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.d-colors__item:not(.is-current)');
    if (!link) return;
    var picker = mainPicker();
    var direct = document.querySelector('[data-d-direct] [data-d-direct-toggle]');
    var date = document.querySelector('[data-d-direct] [data-d-direct-date]');
    var mount = document.querySelector('[data-d-mount] input[type="radio"]:checked');
    var data = { t: Date.now(), sizes: [], direct: !!(direct && direct.checked), date: date ? date.value : '', mount: mount ? mount.value : '' };
    if (picker) picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { data.sizes.push(r.value); });
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (err) {}
  });
  function restore() {
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (err) {}
    if (!data || Date.now() - data.t > 10 * 60 * 1000) return;
    /* Taille d'abord (si ce coloris l'a) : la date est revérifiée ensuite avec la bonne taille */
    var picker = mainPicker();
    (data.sizes || []).forEach(function (v) {
      if (!picker) return;
      var radio = Array.prototype.filter.call(picker.querySelectorAll('input[type="radio"]'), function (r) { return r.value === v; })[0];
      if (radio && !radio.checked) radio.click();
    });
    if (data.mount) {
      var opt = Array.prototype.filter.call(document.querySelectorAll('[data-d-mount] input[type="radio"]'), function (r) { return r.value === data.mount; })[0];
      if (opt && !opt.checked) { opt.checked = true; opt.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var direct = document.querySelector('[data-d-direct] [data-d-direct-toggle]');
    var date = document.querySelector('[data-d-direct] [data-d-direct-date]');
    if (direct && data.direct) direct.checked = true;
    if (date && data.date) date.value = data.date;
    if ((direct && data.direct) || (date && data.date)) (date || direct).dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
})();
